import { Box, Drawer, IconButton, Stack, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';

import CloseIcon from '@mui/icons-material/Close';
import RegistrationProfile from '../features/PreEnrollment/RegistrationProfile';
import { purgeUrlSearchParams } from '../utils/purge-search-params.util';
import { useEffect } from 'react';
import useProfileDrawerStore from '../stores/useProfileDrawerStore';
import { useAnalyticsContext } from '@/utils/analytics/AnalyticsContext';

const ProfileDrawer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { track } = useAnalyticsContext();

  const { profileDrawerShown, hideProfileDrawer, showProfileDrawer } = useProfileDrawerStore();

  useEffect(() => {
    if (!profileDrawerShown) return;

    track('Profile Drawer Shown', {
      title: 'PROFILE',
      url: location.pathname,
      path: location.pathname + '#profile-update',
      referrer: location.pathname,
    });
  }, [location.pathname, profileDrawerShown]);

  useEffect(() => {
    if (location?.hash === '#profile') {
      showProfileDrawer();
    }
  }, [location, showProfileDrawer]);

  useEffect(() => {
    if (profileDrawerShown) {
      navigate({ hash: 'profile' });
    } else {
      // This if statement is to prevent unecessary calls to navigate when the Profile
      // drawer is closed, it will be only called when the #profile is on the URL
      if (location.hash === '#profile') {
        navigate({ hash: '', search: purgeUrlSearchParams(location.search) });
      }
    }
  }, [location.search, navigate, profileDrawerShown]);

  return (
    <Drawer
      anchor="right"
      open={profileDrawerShown}
      onClose={hideProfileDrawer}
      slotProps={{ backdrop: { style: { backgroundColor: 'rgba(8, 10, 45, 0.1)' } } }}
    >
      <Stack p={3} justifyContent="center" alignItems="center" maxWidth={513}>
        <Stack direction="row" style={{ width: '100%' }} justifyContent="space-between">
          <Box>
            <Typography variant="h4" id="ProfileHeader">
              Profile
            </Typography>
            <Typography id="ProfileSubHeader" sx={{ marginTop: '8px', marginBottom: '24px' }}>
              Edit your profile information below.
            </Typography>
          </Box>
          <Box>
            <IconButton
              color="inherit"
              aria-label="close drawer"
              style={{ position: 'relative', bottom: '10px' }}
              onClick={() => hideProfileDrawer()}
              edge="start"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </Stack>
        <RegistrationProfile />
      </Stack>
    </Drawer>
  );
};
export default ProfileDrawer;
